module.exports = __webpack_public_path__ + "img/indomaret.b62cb1d6.jpg";